


import { useState, useEffect } from "react";
import axios from "axios";
import Footer from "../../../components/Footer/Footer";
import InnerNav from "../../../components/InnerNav/InnerNav";
import Zodiac from "../../../components/ZodiacSign/Zodiac";
import MuhuratLink from "../../../components/MuhuratLink/MuhuratLink";
import "./Jain.scss";
import city from '../../../city.json'

const Jain = () => {

  const jainPachchakkhaanTooltips = {
  "Day First Prahar": "The first segment of the day, starting from sunrise and lasting about 3 hours. Important for beginning daily rituals.",
  "Day Second Prahar": "The second segment of daytime, continuing the morning period with spiritual significance and key events like Porshi.",
  "Day Third Prahar": "Midday period, often used for meditation and spiritual focus such as Purimaddha.",
  "Day Fourth Prahar": "Late morning segment leading to sunset, featuring events like Avaddha and Chovihar.",
  "Night First Prahar": "The first part of the night, starting at sunset, includes Evening Pratikraman, a key Jain ritual.",
  "Night Second Prahar": "Second night segment, marked by Santhara Porshi, a solemn spiritual practice.",
  "Night Third Prahar": "Midnight segment, Nishita, considered very auspicious for meditation and spiritual observances.",
  "Night Fourth Prahar": "Final night segment before sunrise, includes Morning Pratikraman to begin the next day with rituals.",
};



  const months = [
    "Jan","Feb","Mar","Apr","May","Jun",
    "Jul","Aug","Sep","Oct","Nov","Dec"
  ];


  const [selectedSegment, setSelectedSegment] = useState(null);
const handleSegmentClick = (seg, period) => {
  setSelectedSegment({
    label: seg.label,
    start: seg.start,
    end: seg.end,
    events: seg.events || {},
    period, // Sunrise / Sunset
    date: readableDate,
    weekday: weekDay,
    location,
    description:
      jainPachchakkhaanTooltips[seg.label] || "No description available",
  });
};

  const [currentDate, setCurrentDate] = useState(new Date());
  const [location, setLocation] = useState("New Delhi, India");
  const [sunriseSegments, setSunriseSegments] = useState([]);
  const [sunsetSegments, setSunsetSegments] = useState([]);
  const [timeFormat, setTimeFormat] = useState("12");

      // Temporary states for user input for submit button
const [tempDate, setTempDate] = useState(currentDate);
const [tempLocation, setTempLocation] = useState("Kolkata");
const [suggestions, setSuggestions] = useState([]);


  useEffect(() => {
    const fetchJainData = async () => {
      const formattedDate = currentDate.toISOString().split("T")[0];
      if (!location || location.trim() === "") return;

      try {
        const response = await axios.get(
          `https://core-c343.onrender.com/api/jain?date=${formattedDate}&location=${encodeURIComponent(location)}`
        );

        const data = response.data.jainPachchakkhaan;

        // Parse sunrise and sunset times for comparison
        // We'll convert to minutes from midnight for easier comparison
        const toMinutes = (timeStr) => {
          // Example timeStr: "11:32 PM"
          if (!timeStr) return 0;
          let [time, ampm] = timeStr.split(" ");
          let [h, m] = time.split(":").map(Number);
          if (ampm === "PM" && h !== 12) h += 12;
          if (ampm === "AM" && h === 12) h = 0;
          return h * 60 + m;
        };

        const sunriseMin = toMinutes(data.sunrise);
        const sunsetMin = toMinutes(data.sunset);

        // Separate segments based on start time relative to sunset time
        const sunriseSegs = [];
        const sunsetSegs = [];

        data.segments.forEach((segment) => {
          const segStartMin = toMinutes(segment.start);
          if (segStartMin <= sunsetMin) {
            sunriseSegs.push(segment);
          } else {
            sunsetSegs.push(segment);
          }
        });

        setSunriseSegments(sunriseSegs);
        setSunsetSegments(sunsetSegs);
      } catch (err) {
        console.error("Failed to fetch Jain Panchagam:", err);
      }
    };

    fetchJainData();
  }, [currentDate, location]);

  const handlePrevDay = () => {
    const prev = new Date(currentDate);
    prev.setDate(prev.getDate() - 1);
    setCurrentDate(prev);
  };

  const handleNextDay = () => {
    const next = new Date(currentDate);
    next.setDate(next.getDate() + 1);
    setCurrentDate(next);
  };

  const handleDateInput = (e) => {
    setTempDate(new Date(e.target.value));
  };

const handleMonthClick = (monthIndex) => {
  const newDate = new Date(tempDate);
  newDate.setMonth(monthIndex);
  setTempDate(newDate);
};

const handleDayClick = (day) => {
  const newDate = new Date(tempDate);
  newDate.setDate(day);
  setTempDate(newDate);
};

const handleSubmit = () => {
  setCurrentDate(tempDate);
  setLocation(tempLocation);
};

  const handleChange = (e) => {
    const value = e.target.value;
    setTempLocation(value);

    // filter cities when user types
    if (value.length > 0) {
      const filtered = city.filter((c) =>
        c.city.toLowerCase().includes(value.toLowerCase())
      );
      setSuggestions(filtered.slice(0, 4)); // show only first 4 results
    } else {
      setSuggestions([]);
    }
  };

  const handleSelect = (cityName) => {
    setTempLocation(cityName);
    setSuggestions([]);
  };

  const formatTime = (timeStr, mode) => {
    if (!timeStr) return "N/A";
    let [time, ampm] = timeStr.split(" ");
    let [hour, minute] = time.split(":").map(Number);
    const isPM = ampm === "PM";

    if (mode === "12") {
      let suffix = isPM ? "PM" : "AM";
      hour = hour % 12 || 12;
      return `${hour}:${minute.toString().padStart(2, "0")} ${suffix}`;
    }

    if (mode === "24") {
      if (isPM && hour !== 12) hour += 12;
      if (!isPM && hour === 12) hour = 0;
      return `${hour.toString().padStart(2, "0")}:${minute.toString().padStart(2, "0")}`;
    }

    if (mode === "24Plus") {
      if (isPM && hour < 12) hour += 12;
      if (!isPM && hour === 12) hour = 0;
      return `${hour.toString().padStart(2, "0")}:${minute.toString().padStart(2, "0")}`;
    }

    return timeStr;
  };

  const formattedDate = currentDate.toISOString().split("T")[0];
  const readableDate = `${months[currentDate.getMonth()]} ${currentDate.getDate()}, ${currentDate.getFullYear()}`;
  const weekDay = currentDate.toLocaleDateString("en-US", { weekday: "long" });


  const parseTimeToDate = (timeStr, referenceDate) => {
  if (!timeStr) return null;
  const [time, meridiem] = timeStr.trim().split(" ");
  let [hours, minutes] = time.split(":").map(Number);
  if (meridiem === "PM" && hours < 12) hours += 12;
  if (meridiem === "AM" && hours === 12) hours = 0;

  const date = new Date(referenceDate);
  date.setHours(hours, minutes, 0, 0);
  return date;
};


const findCurrentSegment = (segments) => {
  const now = new Date();

  for (let segment of segments) {
    const start = parseTimeToDate(segment.start, now);
    const end = parseTimeToDate(segment.end, now);
    if (start && end && now >= start && now <= end) {
      return segment;
    }
  }
  return null;
};


const currentSunriseSegment = findCurrentSegment(sunriseSegments);
const currentSunsetSegment = findCurrentSegment(sunsetSegments);

if (selectedSegment) {
  return (
    <div className="Jain-container">
      <InnerNav />

      <div className="Jain-content">
        <button
          onClick={() => setSelectedSegment(null)}
          style={{
            padding: "8px 14px",
            background: "#b35c00",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
            width: "fit-content",
            marginBottom: "1rem",
          }}
        >
          ← Back
        </button>

<div className="Jain-details jain-report">
  <h2>{selectedSegment.label}</h2>

  <p className="report-subtitle">
    This segment occurs during the <b>{selectedSegment.period}</b>.
  </p>

  <hr />

  <div className="report-section">
    <h4>⏰ Time Period</h4>
    <p>
      {formatTime(selectedSegment.start, timeFormat)} to{" "}
      {formatTime(selectedSegment.end, timeFormat)}
    </p>
  </div>

  <div className="report-section">
    <h4>📅 Date</h4>
    <p>
      {selectedSegment.date} ({selectedSegment.weekday})
    </p>
  </div>

  <div className="report-section">
    <h4>📍 Location</h4>
    <p>{selectedSegment.location}</p>
  </div>

  <hr />

  <div className="report-section">
    <h4>🧿 What does this mean?</h4>
    <p>{selectedSegment.description}</p>
  </div>

  {Object.keys(selectedSegment.events).length > 0 && (
    <>
      <hr />
      <div className="report-section">
        <h4>📌 Associated Events</h4>
        {Object.entries(selectedSegment.events).map(([name, time]) => (
          <p key={name}>
            {name}: {formatTime(time, timeFormat)}
          </p>
        ))}
      </div>
    </>
  )}

  <div className="report-tip">
    Tip: Jain Pachchakkhaan timings are traditionally followed for
    discipline, fasting, and spiritual observances.
  </div>
</div>

      </div>

      <Footer />
    </div>
  );
}

  return (
    <div className="Jain-container">
      <InnerNav />
      <div className="Jain-content">
        <Zodiac />
        <div className="Jain-details">
          <div className="title"> Jain Pachchakkhaan Muhurat Table</div>

          <div className="header">
            <div className="img-details">
              <img
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRW3C3Ty79k_gyPc3OD5oWmoWQk5nXn1bGIYQ&s"
                alt="err"
              />
              <div className="right">
                <div className="current-segment">
                  <h3>Current Sunrise Segment</h3>
                  {currentSunriseSegment ? (
                    <div>
                      <strong>{currentSunriseSegment.label}</strong><br />
                      {formatTime(currentSunriseSegment.start, timeFormat)} to {formatTime(currentSunriseSegment.end, timeFormat)}
                    </div>
                  ) : (
                    <p>No active sunrise segment right now.</p>
                  )}

                  <h3>Current Sunset Segment</h3>
                  {currentSunsetSegment ? (
                    <div>
                      <strong>{currentSunsetSegment.label}</strong><br />
                      {formatTime(currentSunsetSegment.start, timeFormat)} to {formatTime(currentSunsetSegment.end, timeFormat)}
                    </div>
                  ) : (
                    <p>No active sunset segment right now.</p>
                  )}
                </div>

              </div>
            </div>
            <div className="date-display">
              <span className="day">{currentDate.getDate()}</span>
              <span className="month">
                {readableDate}, {weekDay}
              </span>
            </div>
          </div>

          <div className="controls">
            <div className="mode-toggle">
              <button
                onClick={() => setTimeFormat("12")}
                className={timeFormat === "12" ? "active" : ""}
              >
                12 Hour
              </button>
              <button
                onClick={() => setTimeFormat("24")}
                className={timeFormat === "24" ? "active" : ""}
              >
                24 Hour
              </button>
              <button
                onClick={() => setTimeFormat("24Plus")}
                className={timeFormat === "24Plus" ? "active" : ""}
              >
                24 Plus
              </button>
            </div>

            <div className="month-grid">
              {months.map((month, i) => (
                <button key={i} onClick={() => handleMonthClick(i)}>
                  {month}
                </button>
              ))}
            </div>

            <div className="day-grid">
              {Array.from({ length: 31 }, (_, i) => (
                <button key={i} onClick={() => handleDayClick(i + 1)}>
                  {i + 1}
                </button>
              ))}
            </div>

             <div className="location-date">
                   <div className="input-with-icon">
                  <span className="icon">📍</span>
                  <input
                    type="text"
                    value={tempLocation}
                    onChange={handleChange}
                    placeholder="Enter location"
                  />
                  {suggestions.length > 0 && (
                    <ul className="dropdown">
                      {suggestions.map((c, idx) => (
                        <li key={idx} onClick={() => handleSelect(c.city)}>
                          {c.city}, {c.state}, {c.country}
                        </li>
                      ))}
                    </ul>
                  )}
                  </div>
                  <input
                    type="date"
                    value={tempDate.toISOString().split("T")[0]}
                    onChange={handleDateInput}
                  />
                  <button onClick={handlePrevDay}>Prev Day</button>
                  <button onClick={handleNextDay}>Next Day</button>
                  <button onClick={handleSubmit}>Submit</button>

                </div>
          </div>

          <div className="muhurta-section">
            <div className="muhurta-header">
              <div className="muhurta-date">
                {readableDate}, {weekDay}
              </div>
            </div>

            <div className="muhurta-columns">
              <div className="muhurta-column sunrise">
                <span>🌞 Sunrise  Jain Pachchakkhaan Segments</span>
                {sunriseSegments.length === 0 && <p>No data available</p>}
                {/* {sunriseSegments.map((seg, idx) => (
                  <div key={idx} className="muhurta-card orange">
                    <div className="caerdds">
                          <div className="tooltip-wrapper">
                            <div className="title">{seg.label}</div>
                            <span className="tooltip-text">{jainPachchakkhaanTooltips[seg.label] || "No info available"}</span>
                          </div>                      
                          <div className="title">{seg.label}</div>

                    <div className="events">
                        {seg.events &&
                          Object.entries(seg.events).map(([eventName, eventTime]) => (
                            <div key={eventName} className="event">
                              {eventName}: {formatTime(eventTime, timeFormat)}
                            </div>
                          ))}
                      </div>
                    </div>
                    <div className="time">
                      {formatTime(seg.start, timeFormat)} to {formatTime(seg.end, timeFormat)}
                    </div>
                  </div>
                ))} */}
                {sunriseSegments.map((seg, idx) => (
  <div
    key={idx}
    className="muhurta-card orange"
    onClick={() => handleSegmentClick(seg, "Sunrise")}
  >
    <div className="caerdds">
      <div className="title">{seg.label}</div>

      <div className="events">
        {seg.events &&
          Object.entries(seg.events).map(([eventName, eventTime]) => (
            <div key={eventName} className="event">
              {eventName}: {formatTime(eventTime, timeFormat)}
            </div>
          ))}
      </div>
    </div>

    <div className="time">
      {formatTime(seg.start, timeFormat)} to {formatTime(seg.end, timeFormat)}
    </div>
  </div>
))}

              </div>

              <div className="muhurta-column sunset">
                <span> 🌜Sunset  Jain Pachchakkhaan Segments</span>
                {sunsetSegments.length === 0 && <p>No data available</p>}
{sunsetSegments.map((seg, idx) => (
  <div
    key={idx}
    className="muhurta-card red"
    onClick={() => handleSegmentClick(seg, "Sunset")}
  >
    <div className="caerdds">
      <div className="title">{seg.label}</div>

      <div className="events">
        {seg.events &&
          Object.entries(seg.events).map(([eventName, eventTime]) => (
            <div key={eventName} className="event">
              {eventName}: {formatTime(eventTime, timeFormat)}
            </div>
          ))}
      </div>
    </div>

    <div className="time">
      {formatTime(seg.start, timeFormat)} to {formatTime(seg.end, timeFormat)}
    </div>
  </div>
))}

              </div>
            </div>
          </div>
        </div>

        <section className="jain-wrapper">
          <h1 className="jain-title">About Pachakkhan Time</h1>
          <div className="jain-texts">
            <p>
              Pachchakkhaan is also spelled as Pachakkhan, Pachkan, Pachkhan or Pachhakkhan. Pachchakkhaan literally means vow or oath. Pachchakkhaan is ritual to help to follow strict discipline in eating in Jainism.
            </p>
          </div>
        </section>

        <MuhuratLink />
      </div>
      <Footer />
    </div>
  );
};

export default Jain;

